import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { ParentNodeProvider } from '../../providers/ParentNodeProvider';
import { TextContent } from '../TextContent/TextContent';
import { ICustomButton, CustomButton } from '../CustomButton/CustomButton';
import { ConditionalWrapper } from '../../shared/ConditionalWrapper';
import { SmartLink } from '../SmartLink/SmartLink';
import { processLink } from '../../shared/processLink';
import './TwoColumnTextMedia.scss';

export const TwoColumnTextWMedia = ({ node, children }) => {
    const { heading } = node;
    const imgContent = node.relationships?.field_media_content;
    const { field_link_single: mediaLink } = node;
    const customLinks: ICustomButton[] =
        node.relationships?.field_custom_button;

    return (
        <ParentNodeProvider nodeName={heading} nodeType="Two_Column_Text_Media">
            <section
                className={`kite-container themed-container c--two-column-text-media ${node.field_theme?.toLowerCase()}`}
            >
                <div
                    className={`kite-container ${node.field_lr_align?.toLowerCase()}`}
                >
                    <div className="copy">
                        {node.relationships?.field_copy && (
                            <TextContent
                                node={node.relationships?.field_copy}
                            />
                        )}
                        {children && (
                            <section className="two-column-children">
                                {children}
                            </section>
                        )}
                        {customLinks &&
                            customLinks[0]?.field_custom_button_link && (
                                <div className="buttons">
                                    {customLinks.map((link, idx) => (
                                        <CustomButton key={idx} {...link} />
                                    ))}
                                </div>
                            )}
                    </div>
                    {imgContent?.relationships?.field_media_image
                        ?.localFile && (
                        <ConditionalWrapper
                            condition={mediaLink?.uri}
                            wrapper={(children) => (
                                <SmartLink
                                    className={`conditional-wrapper`}
                                    href={processLink(mediaLink.uri)}
                                    aria-label={`${mediaLink.title}`}
                                >
                                    {children}
                                </SmartLink>
                            )}
                        >
                            <>
                                <GatsbyImage
                                    image={getImage(
                                        imgContent?.relationships
                                            ?.field_media_image?.localFile
                                    )}
                                    alt={
                                        imgContent?.field_media_image?.alt ?? ``
                                    }
                                />
                            </>
                        </ConditionalWrapper>
                    )}
                </div>
            </section>
        </ParentNodeProvider>
    );
};
